import { render, staticRenderFns } from "./stock_arrived.vue?vue&type=template&id=051ad2c8&scoped=true"
import script from "./stock_arrived.vue?vue&type=script&lang=js"
export * from "./stock_arrived.vue?vue&type=script&lang=js"
import style0 from "./stock_arrived.vue?vue&type=style&index=0&id=051ad2c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ad2c8",
  null
  
)

export default component.exports